import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import _inheritsLoose from "@babel/runtime/helpers/esm/inheritsLoose";
import React from 'react';
import PropTypes from 'prop-types';
import { Button } from "../../Button";
import { Group } from "../../Group";
import { Input } from "../../Input";
import { CurrencyInput } from "../../CurrencyInput";
import { createPropsGetter } from "../../../lib/createPropsGetter";
import { FunctionIcon, UndoIcon } from "../../../internal/icons/16px";
import { CommonWrapper } from "../../../internal/CommonWrapper";
/** Принимает все свойства `Input`'a */

export var FxInput = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(FxInput, _React$Component);

  function FxInput() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
    _this.input = null;
    _this.getProps = createPropsGetter(FxInput.defaultProps);

    _this.renderMain = function (props) {
      var type = props.type,
          onRestore = props.onRestore,
          auto = props.auto,
          rest = _objectWithoutPropertiesLoose(props, ["type", "onRestore", "auto"]);

      var inputProps = {
        align: 'right'
      };
      var button = null;

      if (auto) {
        inputProps.leftIcon = /*#__PURE__*/React.createElement(FunctionIcon, null);
      } else {
        button = /*#__PURE__*/React.createElement(Button, {
          size: _this.props.size,
          narrow: true,
          onClick: _this.props.onRestore,
          borderless: _this.props.borderless,
          disabled: _this.props.disabled
        }, /*#__PURE__*/React.createElement(UndoIcon, null));
      }

      return /*#__PURE__*/React.createElement(Group, {
        width: _this.props.width
      }, button, _this.getProps().type === 'currency' ? /*#__PURE__*/React.createElement(CurrencyInput, _extends({}, inputProps, rest, {
        width: '100%',
        ref: _this.refInput,
        value: _this.props.value,
        onValueChange: _this.props.onValueChange
      })) : /*#__PURE__*/React.createElement(Input, _extends({}, inputProps, rest, {
        width: '100%',
        ref: _this.refInput,
        type: _this.props.type,
        value: _this.props.value,
        onValueChange: _this.props.onValueChange
      })));
    };

    _this.focus = function () {
      if (_this.input) {
        _this.input.focus();
      }
    };

    _this.blur = function () {
      if (_this.input) {
        _this.input.blur();
      }
    };

    _this.refInput = function (element) {
      _this.input = element;

      if (_this.props.refInput) {
        _this.props.refInput(_this.input);
      }
    };

    return _this;
  }

  var _proto = FxInput.prototype;

  _proto.render = function render() {
    return /*#__PURE__*/React.createElement(CommonWrapper, this.props, this.renderMain);
  };

  return FxInput;
}(React.Component);
FxInput.__KONTUR_REACT_UI__ = 'FxInput';
FxInput.propTypes = {
  auto: PropTypes.bool,
  type: PropTypes.string
};
FxInput.defaultProps = {
  width: 250,
  type: 'text',
  value: ''
};